import { Component, EventEmitter, OnInit } from '@angular/core';
import { OfferService } from 'src/app/offers/services/offer/offer.service';
import { debounceTime } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonService } from '../../services/common/common.service';

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.scss']
})
export class SearchComponent implements OnInit {
  private subject: Subject<string> = new Subject();
  searchItemEvent: EventEmitter<any> = new EventEmitter();
  hideEvent: EventEmitter<boolean> = new EventEmitter();
  selectedItemEvent: EventEmitter<any> = new EventEmitter();
  reloadSubscription: Subscription;

  itemList: Array<any>;


  searchInput = '';
  searching: boolean = false;

  constructor(
    private offerService: OfferService,
    private router: Router,
    private commonService: CommonService
  ) {
  }

  ngOnInit(): void {
    this.subject.pipe(
      debounceTime(700)
    ).subscribe(searchTextValue => {
      if (this.reloadSubscription) {
        this.reloadSubscription.unsubscribe();
      }
      this.searchItem(searchTextValue);
    });
    setTimeout(() => {    //<<<---    using ()=> syntax
      document.getElementById("search-inp")?.focus();
    }, 1000);
  }
  debouncedPopulateMerchantList(searchTextValue: any) {
    this.subject.next(searchTextValue);
  }
  hideModal() {
    this.hideEvent.emit(true);
  }

  searchItem(name) {
    if (this.searchInput.length > 2) {
      this.getMerchants(this.searchInput);
    }
  }
  getMerchants(name) {
    const params = { name };
    // this.searchSubscription.unsubscribe();
    this.searching = true;
    this.reloadSubscription = this.offerService.searchMerchants(params).subscribe(
      (res: any) => {
        let itemArr = [];
        if (res && res.data) {

          this.itemList = res.data.slice(0, 7);
          this.sendAnalyticsData(res.data.slice(0, 7), name)
          setTimeout(() => { this.searching = false; }, 500);
        } else {
          this.searching = false;
          this.itemList = [];
        }
      },
      (err) => {
        console.log(err);
        this.searching = false;
        this.itemList = [];
        this.sendAnalyticsData([], name)
      }
    );
  }
  onItemClick(item) {
    this.hideModal();
    this.router.navigate(['/offers/details/' + item.id + '/all/' + (item?.attributes?.name ? item?.attributes?.name.split(' ').join('-').split(',').join('').split('(').join('').split(')').join('').toLowerCase().trim() : '')]);
  }

  private sendAnalyticsData(data, searchText) {
    const pathname = window.location.pathname;

    let payload = {};
    payload = {
      searchTerm: searchText,
      searchResult: data?.length ? "search_result_found" : "search_result_not_found",
      pageURL: window.location.href,
      pageName: !pathname.includes('offers') ? 'home_page' : `${document.title}`
    }
    this.commonService.sendAnalyticsData('search_click', 'searches' , payload)
  }
}
